import countries from 'i18n-iso-countries'

const defaultLanguage = 'en'

export const getCountryName = (countryCode: string | number, language?: string | null) => {
    const normalizedLanguage = language?.split('-')[0] || defaultLanguage

    return countries.getName(countryCode, normalizedLanguage)
}

export const getCountryEmoji = (countryCode: string) =>
    [...countryCode.toUpperCase()]
        .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
        .reduce((a, b) => `${a}${b}`)
